export const cartFullSvg = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="96.277"
        height="77.047"
        viewBox="0 0 96.277 77.047"
    >
        <g
            id="shopping-cart_1_"
            data-name="shopping-cart (1)"
            transform="translate(-0.625 -12.086)"
        >
            <path
                id="Path_7934"
                data-name="Path 7934"
                d="M57.054,41.009,29.421,47.527,26.406,20.955,47.877,15.89Z"
                transform="translate(9.002 1.328)"
                fill="#fe7058"
            />
            <path
                id="Path_7935"
                data-name="Path 7935"
                d="M57.05,41.012l-3.346.8L45.487,19.33,26.734,23.756l-.324-2.806L47.876,15.89Z"
                transform="translate(9.004 1.328)"
                fill="#ea6453"
            />
            <path
                id="Path_7936"
                data-name="Path 7936"
                d="M32.315,26.216a.675.675,0,0,1-.656-.519l-1.611-6.83a5.514,5.514,0,1,1,10.733-2.531l1.61,6.832a.675.675,0,0,1-1.314.309l-1.611-6.83a4.164,4.164,0,1,0-8.1,1.912l1.611,6.83a.675.675,0,0,1-.5.81A.7.7,0,0,1,32.315,26.216Z"
                transform="translate(10.222)"
                fill="#323c6b"
            />
            <path
                id="Path_7937"
                data-name="Path 7937"
                d="M29.6,48.377a.675.675,0,0,1-.675-.6L25.91,21.206a.675.675,0,0,1,.515-.733L47.9,15.4a.675.675,0,0,1,.788.425l9.174,25.119a.675.675,0,0,1-.479.888L29.751,48.36a.69.69,0,0,1-.155.018ZM27.319,21.649l2.863,25.23L56.334,40.7,47.62,16.859Z"
                transform="translate(8.828 1.152)"
                fill="#323c6b"
            />
            <path
                id="Path_7938"
                data-name="Path 7938"
                d="M0,0H20.272V14.956H0Z"
                transform="translate(66.581 25.322) rotate(8.681)"
                fill="#fcd462"
            />
            <path
                id="Path_7939"
                data-name="Path 7939"
                d="M68.033,40.574a.689.689,0,0,1-.1-.009L47.891,37.508a.675.675,0,0,1-.564-.768l2.26-14.784a.675.675,0,0,1,.27-.443.665.665,0,0,1,.5-.123l20.033,3.059a.675.675,0,0,1,.564.769L68.7,40a.675.675,0,0,1-.666.572Zm-19.27-4.3,18.705,2.855,2.053-13.45L50.815,22.826Z"
                transform="translate(16.305 3.246)"
                fill="#323c6b"
            />
            <path
                id="Path_7940"
                data-name="Path 7940"
                d="M0,0H23.445V4.583H0Z"
                transform="translate(65.705 20.551) rotate(8.681)"
                fill="#fcd462"
            />
            <path
                id="Path_7941"
                data-name="Path 7941"
                d="M71.68,27.264a.674.674,0,0,1-.1-.008L48.4,23.72a.675.675,0,0,1-.564-.769l.692-4.531a.675.675,0,0,1,.769-.564L72.48,21.391a.675.675,0,0,1,.564.769l-.7,4.528a.675.675,0,0,1-.667.572ZM49.274,22.485,71.116,25.82l.488-3.2L49.761,19.289Z"
                transform="translate(16.483 2.012)"
                fill="#323c6b"
            />
            <path
                id="Path_7942"
                data-name="Path 7942"
                d="M59.144,21.75a.659.659,0,0,1-.1-.008c-3.229-.492-5.75-.989-6.4-2.5a2.563,2.563,0,0,1,.513-2.519,2.078,2.078,0,0,1,1.917-1.036c2.218.179,4.288,4.28,4.68,5.1a.675.675,0,0,1-.608.966Zm-4.235-4.722c-.124,0-.355.049-.646.465-.254.366-.526.873-.379,1.214.318.741,2.294,1.193,4.03,1.484-.886-1.521-2.1-3.1-2.949-3.167Z"
                transform="translate(18.117 1.255)"
                fill="#323c6b"
            />
            <path
                id="Path_7943"
                data-name="Path 7943"
                d="M61.525,21.792a28.413,28.413,0,0,1-4.025-.417.675.675,0,0,1-.393-1.127c.621-.665,3.822-3.953,5.989-3.47a2.076,2.076,0,0,1,1.521,1.561,2.563,2.563,0,0,1-.263,2.563A3.585,3.585,0,0,1,61.525,21.792Zm-2.487-1.554c1.743.235,3.767.394,4.292-.219.243-.283.135-.849,0-1.274-.179-.571-.434-.629-.532-.65-.835-.192-2.46.955-3.76,2.143Z"
                transform="translate(19.66 1.622)"
                fill="#323c6b"
            />
            <path
                id="Path_7944"
                data-name="Path 7944"
                d="M0,0H4.406V19.513H0Z"
                transform="translate(75.115 22.013) rotate(8.681)"
                fill="#fe7058"
            />
            <path
                id="Path_7945"
                data-name="Path 7945"
                d="M58.162,40.235a.675.675,0,0,1-.1-.008L53.7,39.561a.675.675,0,0,1-.565-.769L56.083,19.5a.675.675,0,0,1,.768-.564l4.357.665a.675.675,0,0,1,.565.769l-2.944,19.3A.675.675,0,0,1,58.162,40.235ZM54.574,38.33l3.022.461,2.742-17.956-3.022-.46Z"
                transform="translate(18.334 2.389)"
                fill="#323c6b"
            />
            <path
                id="Path_7946"
                data-name="Path 7946"
                d="M66.519,45.984,38.914,52.123l-2.92-14.484L63.6,31.5Z"
                transform="translate(12.35 6.78)"
                fill="#27ccbc"
            />
            <path
                id="Path_7947"
                data-name="Path 7947"
                d="M39.09,52.972a.675.675,0,0,1-.661-.54L35.5,37.948a.675.675,0,0,1,.515-.792l27.606-6.137a.675.675,0,0,1,.81.526l2.92,14.482a.675.675,0,0,1-.515.792l-27.6,6.137a.685.685,0,0,1-.144.016ZM36.962,38.329l2.654,13.16L65.9,45.643l-2.654-13.16Z"
                transform="translate(12.174 6.605)"
                fill="#d5d6db"
            />
            <path
                id="Path_7948"
                data-name="Path 7948"
                d="M80.917,64.572H28.459l-7.531-38H87.11Z"
                transform="translate(7.09 5.057)"
                fill="#eeefee"
            />
            <path
                id="Path_7949"
                data-name="Path 7949"
                d="M87.108,26.57,80.915,64.577H76.233L81.7,31.022H21.807L20.93,26.57Z"
                transform="translate(7.09 5.057)"
                fill="#e1e6e9"
            />
            <path
                id="Path_7950"
                data-name="Path 7950"
                d="M34.741,57.709,32.578,30.986"
                transform="translate(11.158 6.599)"
                fill="#84879c"
            />
            <path
                id="Path_7951"
                data-name="Path 7951"
                d="M34.914,58.559a.675.675,0,0,1-.675-.619L32.081,31.215a.677.677,0,0,1,1.349-.109l2.159,26.725a.675.675,0,0,1-.618.727Z"
                transform="translate(10.983 6.424)"
                fill="#d5d6db"
            />
            <path
                id="Path_7952"
                data-name="Path 7952"
                d="M42.166,57.709l-.723-26.723"
                transform="translate(14.253 6.599)"
                fill="#84879c"
            />
            <path
                id="Path_7953"
                data-name="Path 7953"
                d="M42.341,58.559a.675.675,0,0,1-.675-.656L40.942,31.18a.675.675,0,0,1,.656-.693.683.683,0,0,1,.693.656l.725,26.725a.675.675,0,0,1-.656.693Z"
                transform="translate(14.078 6.425)"
                fill="#d5d6db"
            />
            <path
                id="Path_7954"
                data-name="Path 7954"
                d="M50.494,30.986l-.723,26.723"
                transform="translate(17.161 6.599)"
                fill="#84879c"
            />
            <path
                id="Path_7955"
                data-name="Path 7955"
                d="M49.946,58.559h-.019a.675.675,0,0,1-.656-.693L50,31.141a.675.675,0,0,1,1.349.036L50.62,57.9A.675.675,0,0,1,49.946,58.559Z"
                transform="translate(16.986 6.424)"
                fill="#d5d6db"
            />
            <path
                id="Path_7956"
                data-name="Path 7956"
                d="M59.732,30.986,57.569,57.709"
                transform="translate(19.884 6.599)"
                fill="#84879c"
            />
            <path
                id="Path_7957"
                data-name="Path 7957"
                d="M57.745,58.559H57.69a.675.675,0,0,1-.618-.727L59.23,31.107a.677.677,0,0,1,1.349.109L58.421,57.941A.675.675,0,0,1,57.745,58.559Z"
                transform="translate(19.71 6.424)"
                fill="#d5d6db"
            />
            <path
                id="Path_7958"
                data-name="Path 7958"
                d="M81.091,65.422H28.634a.675.675,0,0,1-.661-.54L20.442,26.876a.675.675,0,0,1,.661-.81H87.284a.675.675,0,0,1,.666.784l-6.193,38a.675.675,0,0,1-.667.569Zm-51.9-1.349h51.33l5.974-36.653H21.924Z"
                transform="translate(6.915 4.881)"
                fill="#323c6b"
            />
            <path
                id="Path_7959"
                data-name="Path 7959"
                d="M65.69,65.4h-6V61.352h6a2.024,2.024,0,0,1,0,4.048Z"
                transform="translate(20.624 17.203)"
                fill="#e1e6e9"
            />
            <path
                id="Path_7960"
                data-name="Path 7960"
                d="M65.864,66.249h-6a.675.675,0,0,1-.675-.675V61.527a.675.675,0,0,1,.675-.675h6a2.7,2.7,0,0,1,0,5.4ZM60.537,64.9h5.327a1.349,1.349,0,0,0,0-2.7H60.537Z"
                transform="translate(20.449 17.028)"
                fill="#323c6b"
            />
            <path
                id="Path_7961"
                data-name="Path 7961"
                d="M37,61.352H60.962V65.4H37Z"
                transform="translate(12.702 17.203)"
                fill="#e1e6e9"
            />
            <path
                id="Path_7962"
                data-name="Path 7962"
                d="M61.136,66.249H37.175a.675.675,0,0,1-.675-.675V61.527a.675.675,0,0,1,.675-.675H61.136a.675.675,0,0,1,.675.675v4.048a.675.675,0,0,1-.675.675ZM37.849,64.9H60.462V62.2H37.849Z"
                transform="translate(12.527 17.028)"
                fill="#323c6b"
            />
            <path
                id="Path_7963"
                data-name="Path 7963"
                d="M42.834,80.372l.173-4.048H38.188a3.961,3.961,0,0,1-3.721-3.192l-9.8-48.209a8.122,8.122,0,0,0-7.941-6.487H9.937v4.048h6.786A4.062,4.062,0,0,1,20.7,25.722l9.8,48.208a8,8,0,0,0,7.516,6.437Z"
                transform="translate(3.252 2.217)"
                fill="#e1e6e9"
            />
            <path
                id="Path_7964"
                data-name="Path 7964"
                d="M43.008,81.22H38.191a8.677,8.677,0,0,1-8.177-6.978l-9.8-48.206a3.386,3.386,0,0,0-3.314-2.7H10.113a.675.675,0,0,1-.675-.675V18.615a.675.675,0,0,1,.675-.675H16.9a8.8,8.8,0,0,1,8.6,7.027l9.8,48.212a3.292,3.292,0,0,0,3.09,2.653h4.79a.675.675,0,0,1,.675.7l-.173,4.048A.675.675,0,0,1,43.008,81.22ZM10.787,21.984H16.9a4.741,4.741,0,0,1,4.636,3.778l9.8,48.208a7.323,7.323,0,0,0,6.881,5.9h4.143l.115-2.7H38.359a4.643,4.643,0,0,1-4.384-3.735l-9.8-48.2a7.446,7.446,0,0,0-7.286-5.946H10.78Z"
                transform="translate(3.077 2.044)"
                fill="#323c6b"
            />
            <circle
                id="Ellipse_1879"
                data-name="Ellipse 1879"
                cx="6.792"
                cy="6.792"
                r="6.792"
                transform="translate(41.204 74.873)"
                fill="#707583"
            />
            <path
                id="Path_7965"
                data-name="Path 7965"
                d="M37.663,73.058a7.466,7.466,0,1,1,7.474-7.471A7.466,7.466,0,0,1,37.663,73.058Zm0-13.584a6.117,6.117,0,1,0,6.125,6.11A6.117,6.117,0,0,0,37.663,59.474Z"
                transform="translate(10.329 16.076)"
                fill="#323c6b"
            />
            <circle
                id="Ellipse_1880"
                data-name="Ellipse 1880"
                cx="3.114"
                cy="3.114"
                r="3.114"
                transform="translate(44.884 78.552)"
                fill="#bbbbcd"
            />
            <path
                id="Path_7966"
                data-name="Path 7966"
                d="M36.715,68.428a3.789,3.789,0,1,1,3.793-3.791A3.788,3.788,0,0,1,36.715,68.428Zm0-6.226a2.438,2.438,0,1,0,1.726.711,2.439,2.439,0,0,0-1.726-.711Z"
                transform="translate(11.281 17.028)"
                fill="#323c6b"
            />
            <path
                id="Path_7967"
                data-name="Path 7967"
                d="M14.02,25.046H4.685a4.06,4.06,0,1,1,0-8.119H14.02a4.06,4.06,0,0,1,0,8.119Zm-9.335-6.77a2.711,2.711,0,0,0,0,5.421H14.02a2.711,2.711,0,1,0,0-5.421Z"
                transform="translate(0 1.69)"
                fill="#323c6b"
            />
            <circle
                id="Ellipse_1881"
                data-name="Ellipse 1881"
                cx="6.792"
                cy="6.792"
                r="6.792"
                transform="translate(71.032 74.873)"
                fill="#707583"
            />
            <path
                id="Path_7968"
                data-name="Path 7968"
                d="M59.771,73.058a7.466,7.466,0,1,1,7.474-7.471A7.466,7.466,0,0,1,59.771,73.058Zm0-13.584a6.117,6.117,0,1,0,6.125,6.11A6.117,6.117,0,0,0,59.771,59.474Z"
                transform="translate(18.049 16.076)"
                fill="#323c6b"
            />
            <path
                id="Path_7969"
                data-name="Path 7969"
                d="M13.845,17.427H4.51a3.385,3.385,0,1,0,0,6.77h9.335a3.385,3.385,0,0,0,0-6.77Z"
                transform="translate(0.175 1.865)"
                fill="#707583"
            />
            <path
                id="Path_7970"
                data-name="Path 7970"
                d="M14.02,25.046H4.685a4.06,4.06,0,1,1,0-8.119H14.02a4.06,4.06,0,0,1,0,8.119Zm-9.335-6.77a2.711,2.711,0,0,0,0,5.421H14.02a2.711,2.711,0,1,0,0-5.421Z"
                transform="translate(0 1.69)"
                fill="#323c6b"
            />
            <circle
                id="Ellipse_1882"
                data-name="Ellipse 1882"
                cx="3.114"
                cy="3.114"
                r="3.114"
                transform="translate(74.712 78.552)"
                fill="#bbbbcd"
            />
            <g
                id="Group_12906"
                data-name="Group 12906"
                transform="translate(27.468 44.35)"
            >
                <path
                    id="Path_7971"
                    data-name="Path 7971"
                    d="M58.824,68.428a3.789,3.789,0,1,1,3.791-3.79A3.788,3.788,0,0,1,58.824,68.428Zm0-6.226a2.439,2.439,0,1,0,2.442,2.435A2.439,2.439,0,0,0,58.824,62.2Z"
                    transform="translate(-8.467 -27.322)"
                    fill="#323c6b"
                />
                <path
                    id="Path_7972"
                    data-name="Path 7972"
                    d="M71.5,38.7a.675.675,0,0,1-.667-.783l.22-1.349a.675.675,0,1,1,1.332.216l-.22,1.349a.675.675,0,0,1-.665.567Z"
                    transform="translate(-2.956 -36)"
                    fill="#323c6b"
                />
                <path
                    id="Path_7973"
                    data-name="Path 7973"
                    d="M69.692,51.8a.686.686,0,0,1-.109-.008.675.675,0,0,1-.557-.774L70.837,39.9a.675.675,0,0,1,1.332.217L70.357,51.233A.675.675,0,0,1,69.692,51.8Z"
                    transform="translate(-3.586 -34.836)"
                    fill="#323c6b"
                />
                <path
                    id="Path_7974"
                    data-name="Path 7974"
                    d="M26.338,68.565a.675.675,0,0,1-.453-.174,12.657,12.657,0,0,1-3.932-6.943l-.774-3.811a.675.675,0,0,1,1.321-.27l.776,3.814a11.314,11.314,0,0,0,3.515,6.206.675.675,0,0,1-.453,1.175Z"
                    transform="translate(-20.294 -28.718)"
                    fill="#323c6b"
                />
                <path
                    id="Path_7975"
                    data-name="Path 7975"
                    d="M21.4,56.021a.675.675,0,0,1-.66-.54l-.206-1.012a.675.675,0,0,1,1.321-.27l.206,1.012a.675.675,0,0,1-.661.81Z"
                    transform="translate(-20.52 -29.824)"
                    fill="#323c6b"
                />
            </g>
            <text
                id="FULL"
                transform="translate(47.996 54.35)"
                fill="#323c6b"
                font-size="10"
                font-family="Roboto-Bold, Roboto"
                font-weight="700"
            >
                <tspan x="0" y="0">
                    FULL
                </tspan>
            </text>
        </g>
    </svg>
);

export const bagSvg = (
    <svg
        id="bag"
        xmlns="http://www.w3.org/2000/svg"
        width="13.054"
        height="15.067"
        viewBox="0 0 13.054 15.067"
    >
        <path
            id="Path_7704"
            data-name="Path 7704"
            d="M16.056,13.1l-.91-8.743a1.5,1.5,0,0,0-1.5-1.351H11.991a2.511,2.511,0,0,0-4.921,0H5.413a1.5,1.5,0,0,0-1.5,1.35L3,13.1v.05a2.916,2.916,0,0,0,2.91,2.913h7.231a2.916,2.916,0,0,0,2.913-2.913A.446.446,0,0,0,16.056,13.1ZM9.531,2a1.509,1.509,0,0,1,1.421,1H8.11A1.509,1.509,0,0,1,9.531,2Zm3.616,13.056H5.915a1.908,1.908,0,0,1-1.908-1.884l.908-8.712a.5.5,0,0,1,.5-.452h8.235a.5.5,0,0,1,.5.452l.9,8.712a1.908,1.908,0,0,1-1.908,1.884Z"
            transform="translate(-3.005 -0.995)"
            fill="#fff"
        />
        <path
            id="Path_7705"
            data-name="Path 7705"
            d="M15.519,11a.5.5,0,0,0-.5.5A1.506,1.506,0,1,1,12,11.5a.5.5,0,0,0-1,0,2.511,2.511,0,1,0,5.022,0A.5.5,0,0,0,15.519,11Z"
            transform="translate(-6.985 -5.976)"
            fill="#fff"
        />
    </svg>
);
